module.exports = __webpack_public_path__ + "img/email-not-sent.48924bc6.svg";